var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"platform-page"},[_c('h1',[_vm._v(_vm._s(_vm.platformName)+" Gaming")]),_c('p',[_vm._v("Latest news, reviews and guides for "+_vm._s(_vm.platformName)+".")])])
}
var staticRenderFns = []

export { render, staticRenderFns }